import React, { Component } from 'react';
import axios from 'axios';
import Axios from './../../Axios'
import './FileUpload.css'
import LoaderSmall from '../LoaderSmall'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ProgressBar from '../ProgressBar/ProgressBar';
import { Urls } from '../../Urls'
import Loader from '../Loader';
import { logActivity } from '../Utilities';
class FileUpload extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedFile: null,
            unit: 'Truck Load',
            metric_rate: 'PTPK',
            isFileSelected: false,
            isUploaded: false,
            isLoading: false
        }
    }

    componentDidMount = () => {
        // logActivity([
        //     {
        //         'screen': 'Upload Dataset File',
        //         'module': 'Upload File File',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | File Upload"
        // Check whether user is logged in or not
        // If not then redirect user to metadata page
        if (!window.localStorage.getItem("userid")) {
            this.props.history.push({
                pathname: "/user_details"
            })
        }
        else {
            // Retrieving userid and dataset_id from local storge
            this.setState({
                userid: window.localStorage.getItem("userid"),
                dataset_id: window.localStorage.getItem("dataset_id")
            })
        }
    }


    changeHandler = event => {
        this.setState({
            selectedFile: event.target.files[0],
            isFileSelected: true
        })

    }

    uploadHandler = (e) => {

        if (this.state.isFileSelected === false) {
            toast.error("Please select a file to upload")
            document.getElementById("card").style.border = "1px solid red"
            document.getElementById("card").style.animation = "shake 0.82s cubic-bezier(.36, .07, .19, .97) both"
            document.getElementById("card").style.transform = "translate3d(0, 0, 0)"
            document.getElementById("card").style.backfaceVisibility = "hidden"
            document.getElementById("card").style.perspective = "1000px"
            // document.getElementById("card").style.animation = "none"
        }
        else {
            // logActivity([
            //     {
            //         'screen': 'Upload Dataset File',
            //         'module': 'Upload File File',
            //         'user_activity': 'file uploaded',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            document.getElementById('header').style.opacity = '0.5'
            var current_timestamp = new Date();
            current_timestamp = current_timestamp.toISOString();

            // Getting dataset id from localStorage
            let fileToUpload = localStorage.getItem("dataset_id")
            fileToUpload = fileToUpload.toString() + "---" + this.state.selectedFile.name
            // params_to_pass = stringify(params_to_pass);

            this.setState({ isUploaded: true, isLoading: true }, () => {
                const body = {
                    'action': 'upload',
                    'fileName': fileToUpload,
                    'accountName': 'lnclientdata',
                    'containerName': 'dcrawfile'
                }
                axios.post(Urls.fileService, body)
                    .then(response => {
                        let filePutUrl = (response.data.url)
                        console.log(filePutUrl)
                        axios.put(filePutUrl, this.state.selectedFile, {
                            headers: {
                                "x-ms-blob-type": "blockblob",
                                "x-ms-blob-content-type": this.state.selectedFile.type
                            }
                        })
                            .then(response => {
                                console.log(response)
                                var body = {
                                    "dataset_id": localStorage.getItem("dataset_id"),
                                    "file": fileToUpload,
                                    "unit": this.state.unit,
                                    "keyword": [''],
                                    "metric_rate": this.state.metric_rate
                                }
                                // API call to upload_file
                                axios.post(Urls.upload_file, body)
                                    .then(response => {
                                        document.getElementById('header').style.opacity = '1'
                                        this.setState({ isLoading: false })
                                        console.log(response)
                                        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                                        toast.success("File has been uploaded", this.props.history.push({ pathname: "/header_mapping" }))
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        document.getElementById('header').style.opacity = '1'
                                        this.setState({ isLoading: false })
                                        toast.error("Error while uploading your file",
                                            this.props.history.push({
                                                pathname: "/file_upload"
                                            }))
                                    })
                            })
                            .catch(error => {
                                document.getElementById('header').style.opacity = '1'
                                toast.error("Error while uploading your file")
                                this.setState({ isLoading: false })
                                console.log(error)
                            })


                    })
                    .catch(error => {
                        document.getElementById('header').style.opacity = '1'
                        toast.error("Error while uploading your file")
                        this.setState({ isLoading: false })
                        console.log(error)
                    })
            })
        }
    }

    changeUnitHandler = (event) => {
        this.setState({
            unit: event.target.value
        })
    }

    changeMetricHandler = (event) => {
        this.setState({
            metric_rate: event.target.value
        })
    }

    goBack = () => this.props.history.push({ pathname: "/user_details" })

    goToHeaderMapping = () => this.props.history.push({ pathname: "/header_mapping" })

    goToLocationCleaning = () => this.props.history.push({ pathname: "/uniqueLocation" })

    goToVendorCleaning = () => this.props.history.push({ pathname: "/directMatchVendor" })

    goToTruckCleaning = () => this.props.history.push({ pathname: "/directMatchTruck" })

    goToSummary = () => this.props.history.push({ pathname: "/summaryScreen" })



    render() {
        return (
            <div id="header">
                {/* <div className="cancelContainer">
                    <a id="cancelButton" onClick={this.cancelAxiosRequest}>X</a>
                </div> */}
                <div className="container">
                    <div id="card" className="card">
                        <div className="uploadDivision">
                            <div className="row" style={{ "margin-top": "2%", "margin-bottom": "2%" }}>
                                <div className="col-4 text-center">
                                    <label className="file_upload_label">Select file to upload</label>
                                    <input style={{ marginTop: '10%' }} className="form-control" type="file" onChange={this.changeHandler} />

                                </div>
                                <div className="col-4 unit text-center">
                                    <label>Volume Unit</label><br />
                                    <div className="unit_inputs">
                                        <input type="radio" onChange={this.changeUnitHandler} name="unit" value="Truck Load" checked={this.state.unit === 'Truck Load'} /><span>In Truck Load</span><br />
                                    </div>
                                    <div className="unit_inputs">
                                        <input type="radio" onChange={this.changeUnitHandler} name="unit" value="Per MT" checked={this.state.unit === 'Per MT'} /> <span>In MT</span><br />
                                    </div>
                                    <div className="unit_inputs">
                                        <input type="radio" onChange={this.changeUnitHandler} name="unit" value="Cubic Feet" checked={this.state.unit === "Cubic Feet"} /><span>in Cubic Feet</span><br />
                                    </div>

                                </div>
                                <div className="col-4 unit text-center">
                                    <label>Rate for Metric</label><br />
                                    <div className="unit_inputs">
                                        <input type="radio" onChange={this.changeMetricHandler} name="metric_rate" value="PTPK" checked={this.state.metric_rate === 'PTPK'} /><span>PTPK</span><br />
                                    </div>
                                    <div className="unit_inputs">
                                        <input type="radio" onChange={this.changeMetricHandler} name="metric_rate" value="Per Truck Load" checked={this.state.metric_rate === 'Per Truck Load'} /> <span>Per truck Load</span><br />
                                    </div>
                                    <div className="unit_inputs">
                                        <input type="radio" onChange={this.changeMetricHandler} name="metric_rate" value="PMT" checked={this.state.metric_rate === "PMT"} /><span>PMT</span><br />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div>
                            <ToastContainer />
                        </div>
                        <div align="center">
                            <button style={{ marginRight: '2%' }} className="btn btn-danger" onClick={this.goBack}>Go Back</button>
                            <button style={{ "margin-right": "2%" }} onClick={this.uploadHandler} className="btn btn-primary"  >Upload</button>
                        </div>
                    </div>
                </div>
                <Loader isLoading={this.state.isLoading} />
                <div className="footer_div">
                    <ProgressBar progress="7%" />
                </div>
            </div>
        )
    }
}

export default FileUpload
